// 支付应用版本
export const PAYMENT_APP_VERSION = '1.0.0'

// 支付回调地址
export const PAYMENT_CALLBACK_URL = window.location.origin + '/payment/callback'
